import { ArrowRight } from 'lucide-react';

/**
 * «Cómo se combinan la estrategia y los límites» (lote B2, spec 246 punto 4;
 * maqueta #b2-combinan). Va en «Ver un ejemplo» de la ayuda de Reglas. Es un
 * ejemplo fijo, el Colchón Templanza de la maqueta: los números son texto, no
 * se calculan (lo que decide el precio es `aplicarJerarquia`, en el backend).
 */

const PASOS = [
  {
    clave: '1 · La estrategia propone',
    titulo: 'Sostener el margen objetivo',
    numero: '5.364,73',
    texto: 'Apuntar a un margen del 27 % con el costo de 3.916,25.',
  },
  {
    clave: '2 · Los límites recortan',
    titulo: 'Queda permitido de 5.000,00 a 9.144,00',
    numero: '5.364,73',
    texto: 'Está adentro: ningún límite lo mueve. Si pidiera 4.600,00, lo subiría a 5.000,00.',
  },
  {
    clave: '3 · El redondeo termina',
    titulo: 'Terminar en ,99',
    numero: '5.364,99',
    texto: 'Sin salirse de lo permitido.',
  },
];

const ESCALERA = [
  { clave: 'Gana', titulo: 'Este producto' },
  { clave: 'después', titulo: 'Marca o categoría' },
  { clave: 'después', titulo: 'Todo el catálogo' },
];

export function ComoSeCombinan() {
  return (
    <section aria-label="Cómo se combinan la estrategia y los límites" className="space-y-3">
      <div className="flex flex-wrap items-stretch gap-2">
        {PASOS.map((p, i) => (
          <div key={p.clave} className="flex items-center gap-2">
            {i > 0 && <ArrowRight className="h-4 w-4 text-muted-foreground" aria-hidden="true" />}
            <div className="w-56 rounded-md border bg-card p-3">
              <div className="text-xs text-muted-foreground">{p.clave}</div>
              <div className="text-sm font-semibold">{p.titulo}</div>
              <div className="mt-1 text-lg font-semibold tabular-nums">{p.numero}</div>
              <p className="mt-1 text-xs text-muted-foreground">{p.texto}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-3 gap-3 text-sm">
        <div className="rounded-md border bg-card p-3">
          <h4 className="font-semibold">Del mismo tipo, gana el más específico</h4>
          <p className="mt-1 text-muted-foreground">
            Un límite de este producto le gana a uno de su marca o categoría, y ése a uno de todo el
            catálogo.
          </p>
          <div className="mt-2 grid grid-cols-3 gap-1" aria-label="El orden">
            {ESCALERA.map((e) => (
              <div key={e.titulo} className="rounded border px-2 py-1">
                <div className="text-xs text-muted-foreground">{e.clave}</div>
                <div className="text-xs font-semibold">{e.titulo}</div>
              </div>
            ))}
          </div>
          <p className="mt-2 text-xs text-muted-foreground">
            Todo el catálogo: «No ganar menos de 18 %». Este colchón: «No ganar menos de 12 %». Para
            este colchón rige <strong className="text-foreground">12 %</strong>, aunque sea menos
            exigente: es una excepción a propósito.
          </p>
        </div>
        <div className="rounded-md border bg-card p-3">
          <h4 className="font-semibold">De tipos distintos, se cumplen todos</h4>
          <p className="mt-1 text-muted-foreground">
            Decide el más exigente: el piso más alto y el techo más bajo.
          </p>
          <p className="mt-2 text-xs text-muted-foreground">
            «No ganar menos de 18 %» deja desde 4.775,92. «No vender por debajo de Bs 5.000,00» deja
            desde 5.000,00. Se cumplen los dos: el piso es{' '}
            <strong className="text-foreground">5.000,00</strong>.
          </p>
        </div>
        <div className="rounded-md border bg-card p-3">
          <h4 className="font-semibold">Si el piso queda arriba del techo, es un conflicto</h4>
          <p className="mt-1 text-muted-foreground">
            Ningún precio cumple todo. El producto{' '}
            <strong className="text-foreground">no se mueve</strong> y te espera en Por decidir con
            la etiqueta «Conflicto entre reglas».
          </p>
          <p className="mt-2 text-xs text-muted-foreground">
            Sin costo, las reglas de margen{' '}
            <strong className="text-foreground">no se pueden medir</strong>: no frenan ni entran en
            el conflicto, y el producto lo dice.
          </p>
        </div>
      </div>
    </section>
  );
}
